module.exports = __webpack_public_path__ + "static/img/img6.2b65078.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/img6.gif
// module id = wEfR
// module chunks = 0